import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import CancellationPolicyModal from '../Book/components/CancellationPolicyModal';
import UpcomingAppointment from '../../components/UpcomingAppointment';
import ActionBanner from './components/ActionBanner';
import FutureFamilyCTA from './components/FutureFamilyCTA';
import { Title } from '../styled_common';

import './styles.scss';
import { Appointment, ReduxState } from 'kb-shared';
import { History } from 'history';
import { Row, Column } from '../../styled/Grid';

const AppointmentSection = styled.div`
  margin: 50px 0;
`;

const H3 = styled.h3`
  ${({ theme }) => theme.typos.subsectionHeader};
  margin-bottom: 25px;
`;

type Props = {
  history: History;
  pastAppointments: Array<Appointment>;
  scheduledAppointments: Array<Appointment>;
  patientMembership?: {
    membershipId?: string;
    employer?: boolean;
  };
};

class Appointments extends React.Component<Props> {
  state = { showCancelModal: false };

  renderAppointments(appointments: Appointment[]): ReactNode | null {
    return appointments.map(appointment => (
      <Column key={appointment.id} mobile={12} tablet={6} desktop={4}>
        <UpcomingAppointment
          appointment={appointment}
          key={`dashboard-appt-row-${appointment.id}`}
          timeSlot={appointment}
          type={appointment.appointmentType}
          isConfirmation={false}
          onAppointmentCancelled={() => window.location.reload()}
          onReschedule={() => window.location.reload()}
          hasStepper
        />
      </Column>
    ));
  }

  toggleCancelModal = () => {
    this.setState({ showCancelModal: !this.state.showCancelModal });
  };

  render() {
    const { scheduledAppointments, pastAppointments, history } = this.props;
    const { patientMembership } = this.props;
    const numAppointmentsBooked = scheduledAppointments && scheduledAppointments.length;
    const numPastAppointments = pastAppointments && pastAppointments.length;

    const hasEmployerMembership =
      patientMembership && patientMembership.employer && patientMembership.membershipId;

    return (
      <Container className="appointments-container">
        <div className="header-wrapper">
          <Title>Appointments {!hasEmployerMembership ? '& Packages' : ''}</Title>
        </div>
        <div className="body-wrapper">
          <ActionBanner history={history} />
          {!hasEmployerMembership && <FutureFamilyCTA />}
          {!!scheduledAppointments && !!numAppointmentsBooked && (
            <AppointmentSection>
              <H3>
                {numAppointmentsBooked} upcoming appointment{numAppointmentsBooked > 1 && 's'}:
              </H3>
              <Row>{this.renderAppointments(scheduledAppointments)}</Row>
            </AppointmentSection>
          )}
          {!!pastAppointments && !!numPastAppointments && (
            <AppointmentSection>
              <H3>
                {numPastAppointments} past appointment{numPastAppointments > 1 && 's'}:
              </H3>
              <Row>{this.renderAppointments(pastAppointments)}</Row>
            </AppointmentSection>
          )}
        </div>
        <CancellationPolicyModal
          show={this.state.showCancelModal}
          onClickClose={this.toggleCancelModal}
        />
      </Container>
    );
  }
}

const mapStateToProps = (state: ReduxState) => ({
  patientMembership: state.patient.patient.patientMembership
});

export default connect(mapStateToProps)(Appointments);

const Container = styled.div`
  ${({ theme }) => theme.grid.pageContainer};
  margin-top: 100px;
`;
